import React from 'react'
import ClayTable from "@clayui/table";
import { CGE } from '../../../common/components/CGE';


function GenericReportTable({props}) {

  return (
    <CGE.PanelSection title={props.customTitle ? props.customTitle : props?.flagSection ?"Tabla":props.section_2_tables_reports} >
      {props.topContent && (
        <div className="d-flex justify-content-end mb-3">
          {props.topContent}
        </div>
      )}
      <ClayTable class="table table-striped table-autofit show-quick-actions-on-hover table-list table-nowrap tbody-valign-middle thead-valign-middle table-valign-middle" id="table-to-xls">
          <ClayTable.Head>
            <ClayTable.Row>
              {props.newArrTitle?.map((title) => {
                return (
                  <ClayTable.Cell headingCell className="clientCell text-center font-weight-bold"
                  >
                    {title}
                  </ClayTable.Cell>
                );
              })}
            </ClayTable.Row>
          </ClayTable.Head>
          <ClayTable.Body>
            {props.currentArray ? (
              props.currentArray?.map((obj) => { 
                return (
                  <ClayTable.Row className="tableRowCenter" >
                    {Object.keys(obj).map((index) => {
                      return (
                        <ClayTable.Cell className=" txt-with-link clientCell-td table-cell-minw-150 text-truncate" title={obj[index]?.length > 27 ? obj[index] : ''}>
                          {obj[index]}
                        </ClayTable.Cell>)
                    })}
                  </ClayTable.Row>
                );
              })
            ) : (
              <ClayTable.Row>
                <ClayTable.Cell colspan={props.newArrTitle?.length} className="text-no-results  font-weight-bold"></ClayTable.Cell>
              </ClayTable.Row>
            )}
          </ClayTable.Body>
        </ClayTable>
    </CGE.PanelSection>
  )
}

export default GenericReportTable